import { createFileRoute } from '@tanstack/react-router'
import { WebhookForm } from '../../../../features/serviceManagement/webhooks/WebhookForm.tsx'

function RouteComponent() {
	return <WebhookForm />
}

export const Route = createFileRoute('/_app/smp/webhooks/create')({
	component: RouteComponent,
})
